export default "__VITE_ASSET__DJVcZdA4__"